import "./Testimonials.css";
import React, { useState, useRef, useEffect  } from "react";


const testimonialsData = [
  {
    name: "John Smith",
    location: "Miami, FL, USA",
    rating: 5,
    comment: "Shipment Solutions LLC took care of everything with honesty and efficiency. Seamless process!"
  },
  {
    name: "Mark Allen",
    location: "Los Angeles, USA",
    rating: 5,
    comment: "Smooth deal!"
  },
  {
    name: "Aisha Brown",
    location: "Nassau, Bahamas",
    rating: 5,
    comment: "Delivered my vehicle to the Bahamas with no hassle. They truly deliver worldwide!"
  },
  {
    name: "Pedro Santos",
    location: "San Juan, Puerto Rico",
    rating: 4,
    comment: "Professional team that handled shipping perfectly. Highly recommend them for overseas purchases."
  },
  {
    name: "Rina Okada",
    location: "New York, USA",
    rating: 5,
    comment: "Perfect shipping!"
  },
  {
    name: "Lucas Silva",
    location: "São Paulo, Brazil",
    rating: 5,
    comment: "Great price, no hidden fees, and they kept me updated all along. Excellent service."
  },
  {
    name: "Fatima Noor",
    location: "Dallas, TX, USA",
    rating: 5,
    comment: "They helped me find the best deal on my car and made the paperwork easy."
  },
  {
    name: "Derrick Jones",
    location: "Chicago, USA",
    rating: 4,
    comment: "Very fair."
  },
  {
    name: "Grace Lee",
    location: "Vancouver, Canada",
    rating: 5,
    comment: "From first call to final delivery, everything was smooth and transparent. Five stars!"
  },
  {
    name: "Samuel Brown",
    location: "London, UK",
    rating: 4,
    comment: "Trustworthy dealership with international expertise. Vehicle arrived exactly as described."
  },
  {
    name: "Nadia Reyes",
    location: "Havana, Cuba",
    rating: 5,
    comment: "Fast service!"
  },
  {
    name: "Sofia Martinez",
    location: "Kingston, Jamaica",
    rating: 5,
    comment: "So impressed with the fast and secure shipment to Jamaica. Amazing customer service."
  },
  {
    name: "Ali Raza",
    location: "London, UK",
    rating: 5,
    comment: "Perfectly handled my imported SUV from the Japan to London"
  },
  {
    name: "Linda Chen",
    location: "Pearland, TX, USA",
    rating: 4,
    comment: "They made sure I got the right price without any surprises. Thank you!"
  },
  {
    name: "James Turner",
    location: "Orlando, USA",
    rating: 5,
    comment: "Love it!"
  },
  {
    name: "Emily Johnson",
    location: "Katy, TX, USA",
    rating: 5,
    comment: "Professional, honest, and quick delivery. Love my new car from Shipment Solutions."
  },
  {
    name: "Yusuf Demir",
    location: "Istanbul, Turkey",
    rating: 5,
    comment: "The entire transaction was handled with care and clarity. Highly recommended."
  },
  {
    name: "Carlos Ramirez",
    location: "El Paso, TX, USA",
    rating: 4,
    comment: "Super friendly staff and no hidden fees. Very smooth process."
  },
  {
    name: "Vanessa Thompson",
    location: "Freeport, Bahamas",
    rating: 5,
    comment: "My car arrived to the Bahamas in perfect condition. Thank you Shipment Solutions!"
  },
  {
    name: "Fatou Diop",
    location: "Dakar, Senegal",
    rating: 5,
    comment: "I trust Shipment Solutions for all my auto imports. They really deliver worldwide."
  }
];


export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = testimonialsData.length;
  const trackRef = useRef();

  useEffect(() => {
    const auto = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(auto);
  }, [total]);

  useEffect(() => {
    if (trackRef.current) {
      const cardWidth = trackRef.current.firstChild.offsetWidth + 16;
      trackRef.current.scrollTo({
        left: cardWidth * currentIndex,
        behavior: "smooth",
      });
    }
  }, [currentIndex]);

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };

  return (
    <div className="testimonials-carousel my-5">
      <h2 className="section-title text-center mb-4">Trusted by Customers Worldwide</h2>
      <div className="testimonial-slider">
        <button className="carousel-btn left" onClick={goPrev}>&laquo;</button>
        <div className="testimonial-track" ref={trackRef}>
          {testimonialsData.map((review, idx) => (
            <div className={`testimonial-card ${idx === currentIndex ? "active" : ""}`} key={idx}>
              <div className="testimonial-rating">
                {Array.from({ length: 5 }, (_, i) => (
                  <span key={i} className={i < review.rating ? "star filled" : "star"}>★</span>
                ))}
              </div>
              <p className="testimonial-comment">"{review.comment}"</p>
              <div className="testimonial-author"><strong>{review.name}</strong> — {review.location}</div>
            </div>
          ))}
        </div>
        <button className="carousel-btn right" onClick={goNext}>&raquo;</button>
      </div>
      <div className="dots text-center mt-3">
        {testimonialsData.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
          ></span>
        ))}
      </div>
    </div>
  );
}